import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from "reactstrap";
import SVG from "../svg";
import H3 from "../headings/H3Element";

interface ParentBreadcrumb {
  label: string;
  link?: string;
}
interface PropsTypes {
  mainTitle: string;
  parents?: ParentBreadcrumb[];
  parent?: string;
  parentLink?: string;
}

const Breadcrumbs = ({
  mainTitle,
  parents,
  parent,
  parentLink,
}: PropsTypes) => {
  // Use parents array if provided, else fallback to single parent
  const computedParents: ParentBreadcrumb[] = parents
    ? parents
    : parent
    ? [{ label: parent, link: parentLink }]
    : [];

  return (
    <Container fluid>
      <div className="page-title">
        <Row>
          <Col sm="6" className="ps-0">
            <H3>{mainTitle}</H3>
          </Col>
          <Col sm="6" className="ps-0">
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                  <SVG iconId="stroke-home" className="stroke-icon" />
                </Link>
              </BreadcrumbItem>
              {computedParents.map((parent, idx) => (
                <BreadcrumbItem key={idx}>
                  {parent.link ? (
                    <Link to={parent.link}>{parent.label}</Link>
                  ) : (
                    parent.label
                  )}
                </BreadcrumbItem>
              ))}
              <BreadcrumbItem active>{mainTitle}</BreadcrumbItem>
            </Breadcrumb>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Breadcrumbs;
